import React from "react";
import '../css/footer.css';
import ReactPlayer from "react-player";

export default function Footer() {
    return (
        <>
            <div className="Footer">
                <div className="container-footer">
                    <div className="row">
                        <div className="logo col-md-6 col-lg-5 col-12 ft-1">
                            <img src="../../assets/footer/logo-footer.svg" className="footer"></img>
                            <p className="link kontak bromo">Jl. Bromo No.16, Klojen, Kota Malang, Jawa Timur 65119 Indonesia</p>
                            <h5 className="kontak link">INFORMASI KONTAK</h5>
                            <ul>
                                <li className="nav-item">
                                    <a className="item" href="/">T: (0341) 368639</a>
                                </li>
                                <li className="nav-item">
                                    <a className="item" href="/">E: smalabum@yahoo.com</a>
                                </li>
                            </ul>
                        </div>
                        <div className="center col-md-6 col-lg-3 col-12 ft-2" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    <div>
        <h5 className="link">Profil Sekolah</h5>
        <ul>
            <li className="nav-item">
                <a className="link" href="/">Informasi</a>
            </li>
        </ul>  
    </div>
    <div>
        <h5 className="link">OFFICIAL SOCIAL MEDIA</h5>
        <div className="footer-icons">
            <img src="../../assets/footer/icon1.svg"></img>
            <img src="../../assets/footer/icon2.svg"></img>
            <img src="../../assets/footer/icon3.svg"></img>
            <img src="../../assets/footer/icon4.svg"></img>
        </div>
    </div>
</div>

                        <div className="center centerppdb col-md-6 col-lg-3 col-12 ft-3">
                            <h5 className="link">PPDB 2024</h5>
                            <ul>
                                <li className="nav-item">
                                    <a className="link" href="/">Link Terkait</a>
                                </li>
                            </ul>
                        </div>
                        <div className="ytp col-md-6 col-lg-3 col-12 ft-4">
                            <div style={{borderRadius: '10px', overflow: 'hidden'}}>
                                <ReactPlayer
                                  url='https://youtu.be/INNWpcBHwAY'
                                  controls={true}
                                  width='auto'
                                  height='240px'
                                  style={{borderRadius: '10px'}}
                                />
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            
        </>
    )
}
